import React from 'react';

interface IconAlertCircleProps {
    iconClasses?: string;
}

const IconAlertCircle: React.FC<IconAlertCircleProps> = ({ iconClasses }) => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-alert-circle ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10 7.97949C10.5523 7.97949 11 8.42719 11 8.97949V14.9795C11 15.5317 10.5523 15.9795 10 15.9795C9.44773 15.9795 9.00005 15.5317 9 14.9795V8.97949C9 8.42719 9.4477 7.97949 10 7.97949ZM10 4.05078C10.5522 4.05078 10.9998 4.49866 11 5.05078C11 5.60306 10.5523 6.05078 10 6.05078C9.4477 6.05078 9 5.60306 9 5.05078C9.0002 4.49866 9.44782 4.05078 10 4.05078Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconAlertCircle;
